import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseButton, Modal } from "react-bootstrap";

import BusinessInfoForm from "./BusinessInfoForm";

import {
    selectModalData,
    closeModal,
} from "../redux/slices/businessModalSlice";

import "../styles/components/BusinessInfoModalForm.scss";

const BusinessInfoModalForm = () => {
    const dispatch = useDispatch();
    const { modalId, link, download, source, contentDescription } =
        useSelector(selectModalData);

    const hideModal = () => dispatch(closeModal());

    if (!modalId) return null;

    return (
        <Modal
            className="business-info-modal-form"
            show={!!modalId}
            onHide={hideModal}
            centered
        >
            <CloseButton onClick={hideModal} />
            <Modal.Body>
                <BusinessInfoForm
                    link={link}
                    download={download}
                    contentDescription={contentDescription}
                    source={source}
                />
            </Modal.Body>
        </Modal>
    );
};

export default BusinessInfoModalForm;
